import React, { FunctionComponent } from 'react';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';

import { PeoplePageHeader } from './PeoplePageHeader';

export const PeopleManagement: FunctionComponent = () => {
  return (
    <I18nProviderWrapper>
      <div className="people-management-wrapper">
        <PeoplePageHeader />
      </div>
    </I18nProviderWrapper>
  );
};

export default PeopleManagement;
